import { z } from 'zod';
import { gridBaseSchema } from '../base';
import { responsiveSchema } from '../../../utils';
import { responsiveNumberWithUnitSchema } from '../../../mixins';

const dataSchema = z.object({
    variant: z.coerce.number(),
    gapX: responsiveNumberWithUnitSchema,
    gapY: responsiveNumberWithUnitSchema,
    rowCellWidth: responsiveSchema(z.array(z.array(z.coerce.number()))),
});

export const gridDefaultSchema = gridBaseSchema.extend({
    entitySubType: z.literal('default'),
    props: dataSchema,
    version: z.literal(0),
});

export const gridDefaultV0Schema = gridDefaultSchema;
export type GridDefaultV0 = z.infer<typeof gridDefaultV0Schema>;
